import { IAddOfferResponse, IEditReferral } from "../../utils/types";
import { apiManager } from "../api-manager";

export const addReferralOffer = async (body: IEditReferral) => {
  const res = await apiManager.post<IAddOfferResponse>(
    "/referral-offer/add-offer",
    body
  );
  return res;
};
